class RequestPasswordReset {
	constructor(
		public readonly accountId: number,
		public readonly userId: number,
	) {
		Object.freeze(this);
	}
}

export default RequestPasswordReset;
